/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';

import {
  INotification,
  INotificationResponse,
  INotificationDetails,
  INotificationDetailsParams,
  INotificationClosingParams
} from '../../models';

export const enum ENotificationsActions {
  InitializeNotifications = '[Notifications] Initialize Notifications',
  AddNotifications = '[Notifications] Add notification',
  AddNotificationsSuccess = '[Notifications] Add notification Success',
  UpdateNotificationSuccess = '[Notifications] Update Notifications Success',
  DeleteNotification = '[Notifications] Delete notification',
  DeleteAllNotifications = '[Notifications] Delete All notifications',
  DeletePanicNotification = '[Notifications] Delete panic notification',
  CloseNonPanicNotification = '[Notifications] non panic notification closed',
  ReviewPanic = '[Notifications] Panic Reviewed',
  AcknowledgePanic = '[Notifications] Panic Acknowledged',
  GetPersistedNotifications = '[Notifications] Get persisted notifications',
  GetPersistedNotificationsSuccess = '[Notifications] Get persisted notifications success',
  GetNotificationInfo = '[Notifications] Get notification info',
  GetNotificationInfoSuccess = '[Notifications] Get notification info success',
  StopNonPanicNotifications = '[Notifications] Stop Non Panic Notifications',
  StartNonPanicNotifications = '[Notifications] Start Non Panic Notifications'
}

export class InitializeNotifications implements Action {
  public readonly type = ENotificationsActions.InitializeNotifications;
}

export class AddNotifications implements Action {
  public readonly type = ENotificationsActions.AddNotifications;

  constructor(public payload: INotificationResponse) {}
}

export class AddNotificationsSuccess implements Action {
  public readonly type = ENotificationsActions.AddNotificationsSuccess;

  constructor(public payload: INotification) {}
}

export class UpdateNotificationSuccess implements Action {
  public readonly type = ENotificationsActions.UpdateNotificationSuccess;

  constructor(public payload: INotification) {}
}

export class GetPersistedNotifications implements Action {
  public readonly type = ENotificationsActions.GetPersistedNotifications;
}

export class GetPersistedNotificationsSuccess implements Action {
  public readonly type = ENotificationsActions.GetPersistedNotificationsSuccess;

  constructor(public payload: INotification[]) {}
}

export class GetNotificationInfo implements Action {
  public readonly type = ENotificationsActions.GetNotificationInfo;

  constructor(public payload: INotificationDetailsParams) {}
}

export class GetNotificationInfoSuccess implements Action {
  public readonly type = ENotificationsActions.GetNotificationInfoSuccess;

  constructor(public payload: INotificationDetails) {}
}

export class DeleteNotification implements Action {
  public readonly type = ENotificationsActions.DeleteNotification;

  constructor(public payload: string) {}
}

export class CloseNonPanicNotification implements Action {
  public readonly type = ENotificationsActions.CloseNonPanicNotification;

  constructor(public payload: INotificationClosingParams) {}
}

export class AcknowledgePanic implements Action {
  public readonly type = ENotificationsActions.AcknowledgePanic;

  constructor(public payload: INotification) {}
}

export class ReviewPanic implements Action {
  public readonly type = ENotificationsActions.ReviewPanic;

  constructor(public payload: INotification) {}
}

export class DeleteAllNotifications implements Action {
  public readonly type = ENotificationsActions.DeleteAllNotifications;
}

export class DeletePanicNotification implements Action {
  public readonly type = ENotificationsActions.DeletePanicNotification;

  constructor(public payload: number) {}
}

export class StopNonPanicNotifications implements Action {
  public readonly type = ENotificationsActions.StopNonPanicNotifications;
}

export class StartNonPanicNotifications implements Action {
  public readonly type = ENotificationsActions.StartNonPanicNotifications;
}

export type NotificationsActions =
  | InitializeNotifications
  | AddNotificationsSuccess
  | AddNotifications
  | UpdateNotificationSuccess
  | DeleteNotification
  | DeleteAllNotifications
  | DeletePanicNotification
  | CloseNonPanicNotification
  | AcknowledgePanic
  | ReviewPanic
  | GetPersistedNotifications
  | GetPersistedNotificationsSuccess
  | GetNotificationInfo
  | GetNotificationInfoSuccess
  | StopNonPanicNotifications
  | StartNonPanicNotifications;
